/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import EnvironmentModel from 'cio/models/environment';

interface SettingsEditUserEnvironmentsArgs {
  environments: EnvironmentModel[];
  selectedEnvironments: EnvironmentModel[];
  // TODO: Figure out how this relates to permissions (if at all)
  isAdmin: boolean;
  onChange: (environments: EnvironmentModel[]) => void;
}

export default class SettingsEditUserEnvironments extends Component<SettingsEditUserEnvironmentsArgs> {
  get allSelected() {
    return this.args.selectedEnvironments.length === this.args.environments.length;
  }

  @action
  toggleAll() {
    if (this.args.isAdmin) {
      return;
    }

    if (this.allSelected) {
      this.args.onChange([]);
    } else {
      this.args.onChange(this.args.environments);
    }
  }

  @action
  toggleEnv(env: EnvironmentModel) {
    let { selectedEnvironments } = this.args;
    let environments: EnvironmentModel[];

    if (selectedEnvironments.includes(env)) {
      environments = selectedEnvironments.filter((e) => e.id !== env.id);
    } else {
      environments = [...selectedEnvironments, env];
    }

    this.args.onChange(environments);
  }
}
